<template>
  <div class="watermark" ref="watermark" v-if="posData && posData.length > 0">
    <div class="item" v-for="(item, index) in posData" :style="{ left: item.left, top: item.top }" :key="`idx-${index}`" v-show="!isSupportShadowDom">
      权威数据，科橘正版<br/>{{ currentTime }}
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'Watermark',
  data () {
    return {
      posData: [],
      isSupportShadowDom: true
    }
  },
  computed: {
    currentTime () {
      return dayjs().format('YYYY/MM/DD HH:mm')
    }
  },
  mounted() {
    let ww = window.screen.width || 0
    let hw = window.screen.height || 0
    if (ww && hw) {
      let wdis = 300
      let hdis = 210
      ww = Math.ceil(ww / wdis)
      hw = Math.ceil(hw / hdis)
      let initW = -wdis
      let res = []
      for(let i = 0; i < ww; i++) {
        let initH = -hdis
        for(let j = 0; j < hw; j++) {
          res.push({ left: `${initW}px`, top: `${initH}px` })
          initH += hdis
        }
        initW += wdis
      }
      this.posData = res
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs['watermark'] && this.$refs['watermark'].attachShadow) {
            let shadowDom = this.$refs['watermark'].attachShadow({ mode: 'closed' })
            shadowDom.innerHTML = '<style>.item{ position: absolute; display: inline-flex; justify-content: center; align-items: center; width: 200px; height: 80px; opacity: 0.4; transform: rotate(-45deg); user-select: none; overflow: hidden; font-size: 16px; font-family: Helvetica, "PingFang SC", "Microsoft YaHei", 微软雅黑; text-align: center; color: #c8c8c9; overflow-wrap: break-word; }</style>' + this.$refs['watermark'].innerHTML.replace(/display:\s*none;?/gi, '')
            this.$refs['watermark'].innerHTML = ''
          } else {
            this.isSupportShadowDom = false
          }
        }, 200)
      })
    }
  }
}
</script>

<style scoped>
.watermark{
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  overflow: hidden;
  pointer-events: none;
}
.watermark .item{
    position: absolute;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 200px;
    height: 90px;
    opacity: 0.4;
    transform: rotate(-45deg);
    user-select: none;
    overflow: hidden;
    font-size: 14px;
    font-family: Helvetica, "PingFang SC", "Microsoft YaHei", 微软雅黑;
    text-align: center;
    color: #c8c8c9;
    overflow-wrap: break-word;
}
</style>


// WEBPACK FOOTER //
// src/components/common/Watermark.vue